import '../assets/css/HolidaySection.css';

const HolidaySection = () => {
    return (
        <div>
            {/* Holiday Section */}
            <section className="holiday-section">
                <div className="container">
                    <div className="holiday-image">
                        <div className="sparkle-icon">
                            <i className="fas fa-sparkles" />
                        </div>
                        <img src="/assets/Images/exp.webp" alt="Luxury villa with infinity pool" />
                        <div className="rating-box">
                            <div className="guests">
                                <p>Guests</p>
                                <div className="guest-avatars">
                                    <div className="avatar" style={{ backgroundColor: '#e74c3c' }} />
                                    <div className="avatar" style={{ backgroundColor: '#f39c12' }} />
                                    <div className="avatar" style={{ backgroundColor: '#3498db' }} />
                                    <div className="avatar" style={{ backgroundColor: '#2ecc71' }} />
                                    <div className="avatar-count">1K+</div>
                                </div>
                            </div>
                            <div className="rating">
                                <p>Rating</p>
                                <div className="rating-value">
                                    <span>5</span>
                                    <i className="fas fa-star" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="holiday-content">
                        <h1>The Best Holidays Start Here!</h1>
                        <p className="subtitle">Book your villa with us and don't forget to grab an awesome villa deal to save massive on your stay.</p>
                        <div className="features-grid">
                            <div className="feature">
                                <div className="feature-icon home">
                                    <i className="fas fa-home" />
                                </div>
                                <h3>Exclusive Properties</h3>
                                <p>Handpicked luxurious villas, resorts, and homestays offering unparalleled comfort and privacy.</p>
                            </div>
                            <div className="feature">
                                <div className="feature-icon leaf">
                                    <i className="fas fa-leaf" />
                                </div>
                                <h3>Premium Amenities</h3>
                                <p>Enjoy state-of-the-art facilities, serene pools, and lush green surroundings for a perfect getaway.</p>
                            </div>
                            <div className="feature">
                                <div className="feature-icon star">
                                    <i className="fas fa-star" />
                                </div>
                                <h3>Top-notch Hospitality</h3>
                                <p>Experience warm and professional service that exceeds your expectations.</p>
                            </div>
                            <div className="feature">
                                <div className="feature-icon location">
                                    <i className="fas fa-map-marker-alt" />
                                </div>
                                <h3>Prime Locations</h3>
                                <p>Stay at scenic destinations in Maharashtra and Pattaya, Thailand.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

    );
}

export default HolidaySection;